export default __webpack_public_path__ + "static/media/image13.41f4f4a5.png";